import React from "react";
import {Navigate} from "react-router-dom";
import {CookiesKey, useCookies} from "@/app/utils/cookies";
import {route} from "@/app/routes/AppRoutes";

interface Props {
  children: JSX.Element;
}

const ProtectedRoute: React.FC<Props> = ({children}) => {
  const {getCookie} = useCookies();

  if (getCookie(CookiesKey.token) == null || getCookie(CookiesKey.token) === "") {
    return <Navigate to={route.auth} replace/>;
  }

  return children;
};

export default ProtectedRoute;